import { useEffect, useState } from "react";
import {
  OrdemServicoService,
  notification,
  history,
} from "../../../../../services";
import {
  Dialog,
  Box,
  CardHeader,
  Stepper,
  Step,
  StepLabel,
} from "../../../../../components";
import OrdemServicoStepperContent from "./ordem-servico-stepper-content.component";

const ordemService = new OrdemServicoService();

const ImportarOrdemServicoDialog = ({
  openImportarOrdemServicoDialog,
  setOpenImportarOrdemServicoDialog,
  setLoading,
} = {}) => {
  const [activeStep, setActiveStep] = useState(0);
  const [ordemServicoSelecionadosIds, setOrdemServicoSelecionadosIds] =
    useState([]);
  const [ordensServicos, setOrdensServicos] = useState([]);
  const [servicos, setServicos] = useState([]);
  const [servicoSelecionadosIds, setServicoSelecionadosIds] = useState([]);
  const [nfse, setNfse] = useState({});
  const steps = ["Selecionar Ordens de Serviço", "Selecionar Serviços"];

  useEffect(() => {
    if (openImportarOrdemServicoDialog) {
      setActiveStep(0);
      setServicoSelecionadosIds([]);
      setOrdemServicoSelecionadosIds([]);
      setOrdensServicos([]);
    }
  }, [openImportarOrdemServicoDialog]);

  const buscarOrdensServicos = async (filtro) => {
    if (!filtro.clienteId) {
      return notification.erroValidacao("Cliente");
    }
    if (filtro.dataInicial && filtro.dataFinal) {
      filtro.porIntervalo = [
        {
          coluna: "dataFechamento",
          de: filtro.dataInicial,
          ate: filtro.dataFinal,
        },
      ];
      delete filtro.dataFinal;
      delete filtro.dataInicial;
    }
    const body = {
      ...filtro,
      status: "FECHADO",
      restritiva: true,
      statusExportacao: ["NAO_EXPORTADO", "EXPORTADO_PARCIALMENTE"],
    };
    setLoading(true);
    const res = await ordemService.getAllFiltroAvancado(body);
    setLoading(false);
    if (!res.isAxiosError) {
      setOrdensServicos(res?.data?.rows || []);
    }
  };

  const handleAvancarStep = () => {
    if (!ordemServicoSelecionadosIds?.length)
      return notification.alertaGenericos(
        "Selecione ao menos uma ordem de serviço para importar",
      );
    filtrarServicos(ordemServicoSelecionadosIds);
    setActiveStep(activeStep + 1);
  };

  const handleCancelarImportacao = () => {
    setOpenImportarOrdemServicoDialog(false);
  };

  function filtrarServicos(ordemServicoIds) {
    const servicosFiltrados = [];
    const primeiraOrdem = ordensServicos[0];
    setNfse({
      clienteId: primeiraOrdem?.clienteId || null,
      clienteNome: primeiraOrdem?.clienteNome || null,
      clienteCnpjCpf: primeiraOrdem?.clienteCnpjCpf || null,
      dataPrestacao: primeiraOrdem?.dataFechamento || null,
    });
    ordensServicos.forEach((ordemService) => {
      if (ordemServicoIds.indexOf(ordemService.id) > -1) {
        const listaServicos = ordemService.servicos.filter(
          (servico) =>
            !servico.exportado &&
            servico.classificacaoServicoNacional &&
            servico.aliquotaTotalSimplesNacional &&
            servico.codigoServicoNacional,
        );
        servicosFiltrados.push(...listaServicos);
      }
    });
    setServicos(servicosFiltrados);
  }

  const handleImportarOrdemServico = () => {
    if (!servicoSelecionadosIds?.length) return;
    setOpenImportarOrdemServicoDialog(false);
    const selecionados = servicos.filter(
      (s) => servicoSelecionadosIds.indexOf(s.id) > -1,
    );
    let descricaoServico = null;
    const nfseImport = {
      ...nfse,
      descricaoServico,
      servicos: selecionados.map((s) => {
        const descricao = s.descricao || "";
        if (descricaoServico) {
          descricaoServico = `${descricaoServico}, ${descricao}`;
        } else {
          descricaoServico = descricao;
        }
        return {
          id: s.servicoId || s.id,
          servicoId: s.servicoId || s.id,
          quantidade: s.quantidade || 1,
          valor: s.valor || 0,
          descricao,
          classificacaoServicoNacional: s.classificacaoServicoNacional,
          codigoServicoNacional: s.codigoServicoNacional,
          aliquotaTotalSimplesNacional: s.aliquotaTotalSimplesNacional,
          fatOrdemServicoId: s.ordemServicoId,
        };
      }),
    };
    nfseImport.descricaoServico = descricaoServico;
    window.nfSeEntity = nfseImport;
    history.push("/faturamento/nfse/create");
  };

  return (
    <Dialog fullWidth maxWidth="xl" open={openImportarOrdemServicoDialog}>
      <Box sx={{ m: 2 }}>
        <CardHeader title="Importar Ordem de Serviço" />
      </Box>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <OrdemServicoStepperContent
        activeStep={activeStep}
        setActiveStep={setActiveStep}
        buscarOrdensServicos={buscarOrdensServicos}
        handleAvancarStep={handleAvancarStep}
        handleCancelarImportacao={handleCancelarImportacao}
        handleImportarOrdemServico={handleImportarOrdemServico}
        servicos={servicos}
        servicoSelecionadosIds={servicoSelecionadosIds}
        setServicoSelecionadosIds={setServicoSelecionadosIds}
        ordensServicos={ordensServicos}
        ordemServicoSelecionadosIds={ordemServicoSelecionadosIds}
        setOrdemServicoSelecionadosIds={setOrdemServicoSelecionadosIds}
      />
    </Dialog>
  );
};

export default ImportarOrdemServicoDialog;
